<div class="container d-flex align-items-center justify-content-center" style="height: calc(100vh - 50px);">
    <div class="row justify-content-center">
      <div class="text-center">
        <h1 class="display-1">404</h1>
        <h2 class="display-4">Page Not Found</h2>
        <span>The page you are looking for might have been removed, or you don't have access to it.</span>
      </div>
    </div>
  </div>